import {useMemo} from 'react';

import {useBrandsFilter} from '../../../../../../service/companies-import/companies-import-list-brands-filter';
import {PermissionNameEnum} from '../../../../../../service/company/company-type';
import {Form, FormInstance} from '../../../../../../typings/antd';

import {FeedFormKeyEnum, FeedFormType} from './feed-form-type';

export function useHasNoAccessBrand(form: FormInstance<FeedFormType>, hasBrands?: boolean): boolean {
    const allowedBrands = Form.useWatch(FeedFormKeyEnum.AllowedBrands, form);

    const allowedBrandIds = useMemo(
        () =>
            (allowedBrands ?? [])
                .map((brand) => brand.brandId)
                .filter((brandId): brandId is number => brandId !== null),
        [allowedBrands]
    );

    // eslint-disable-next-line no-undefined
    const {data: brandsPermissionsData} = useBrandsFilter(undefined, allowedBrandIds, {
        enabled: Boolean(hasBrands) && allowedBrandIds.length > 0,
    });

    return useMemo(() => {
        if (!hasBrands) {
            return false;
        }

        const brandsWithPermissions = brandsPermissionsData?.pages.flatMap((page) => page.results) ?? [];

        return allowedBrandIds.some((brandId) => {
            const brand = brandsWithPermissions.find((item) => item.id === brandId);

            return brand ? !brand.permissions.includes(PermissionNameEnum.update) : false;
        });
    }, [allowedBrandIds, brandsPermissionsData, hasBrands]);
}
